<script>
    export default {
        render: function (createElement) {
            return createElement('style', this.$slots.default)
        }
    }
</script>
